const INITIAL_STATE = {
  loginNavigation: true,
  token: "",
  user: [],
};

const reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case "LOGIN_NAVIGATION_OFF":
      return {
        ...state,
        loginNavigation: false,
      };
    case "LOGIN_NAVIGATION":
      return {
        ...state,
        loginNavigation: true,
      };
    case "SET_TOKEN":
      return {
        ...state,
        token: action.data,
      };
    case "SET_USER":
      return {
        ...state,
        user: action.data,
      };
    default:
      return state;
  }
};

export default reducer;
